import { FormControl, Grid } from '@material-ui/core';
import MuiCheckbox from '@material-ui/core/Checkbox/Checkbox';
import React, { ReactElement, useEffect, useState } from 'react';
import { useCheckboxStyles } from './checkbox.styles';

interface CheckboxProps {
  label?: string | ReactElement;
  inputRef?: React.RefObject<HTMLInputElement>;
  name?: string;
  disabled?: boolean;
  value: string;
  onChange?: Function;
  setValue?: Function;
  unregister?: Function;
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  inputRef,
  name,
  disabled,
  value,
  onChange = (): void => { },
  setValue = (): void => { },
  ...props
}): JSX.Element => {
  const { label__disabled, label__default, margin__checkbox } = useCheckboxStyles();
  const [checked, setChecked] = useState<boolean>(value === 'Yes');
  const [fieldValue, setFieldValue] = useState<string>(value || 'No');

  const handleChange = (_event: React.ChangeEvent<HTMLInputElement>, _checked: boolean) => {
    setChecked(_checked);
    setFieldValue(_checked ? 'Yes' : 'No');
  };

  useEffect(() => {
    // The onChange is called here instead of in the handleChange function
    // because, when the checkbox value is changed and handleChange is called,
    // since state change is async, the value of the checkbox is not yet updated
    // Use effect is called after the state is updated/ field value is updated
    if (onChange) {
      setValue(name, fieldValue);
      onChange();
    }
  }, [fieldValue]);

  return (
    <FormControl>
      <Grid container wrap="nowrap" direction="row" alignItems="baseline">
        <Grid item className={margin__checkbox}>
          <MuiCheckbox
            color="primary"
            checked={checked}
            inputRef={inputRef}
            name={name}
            value={fieldValue}
            disabled={disabled}
            {...props}
            className={disabled ? 'disabled' : ''}
            onChange={handleChange}
          />
        </Grid>
        <Grid item>
          <span 
            className={disabled ? label__disabled : label__default} 
            dangerouslySetInnerHTML={{__html: `${label}`}}>              
          </span>
        </Grid>
      </Grid>
    </FormControl>
  );
};

export default Checkbox;